module.exports = __webpack_public_path__ + "static/stable4-d105d1dac2a9d99c6d293bf64335bff3.jpg";